import { createStyles } from '@mantine/core'

export default createStyles(() => {
  return {
    root: {
      position: 'relative',
      cursor: 'pointer',
      height: 40,
      width: 40,
    },
    item: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
  }
})
